//@flow

import { put, takeEvery } from 'redux-saga/effects';
import {
  LOAD_VIDEOS_DETAILS,
  LOAD_VIDEO_TRACK,
  DELETE_VIDEO,
} from '../types/video';
import {
  loadVideosDetailsSuccess,
  loadVideosDetailsFail,
  loadVideoTrackSuccess,
  loadVideoTrackFail,
  deleteVideoSucess,
  deleteVideoFail,
} from '../actions/video';
import type { VideoAction } from '../actions/video';
import { 
    getFlights
} from './../actions/flightManager';

export function* loadVideosDetailsSaga(action: VideoAction): Generator<any, void, any> {
  try {
    const { axiosInstance, id, source }: VideoAction = action;
    let url = ''
    if (source === 'faults')
      url = `faults/${String(id)}/videos`;
    else
      url = `projects/${String(id)}/videos`;

    const res: Response = yield axiosInstance.get(url);
    const { data } = res;
    yield put(loadVideosDetailsSuccess(data));
  } catch (error) {
    yield put(loadVideosDetailsFail(error));
  }
};

export function* loadVideoTrackSaga(action: VideoAction): Generator<any, void, any> {
  try {
    const { axiosInstance, videoId }: VideoAction = action;
    
    let url = `videos/${String(videoId)}/track`;
    const response: Response = yield axiosInstance.get(url);
    const { data } = response;
    yield put(loadVideoTrackSuccess(data));
  } catch (error) {
    yield put(loadVideoTrackFail(error));
  }
};

export function* deleteVideosSaga(action: VideoAction): Generator<any, void, any> {
  try {
    const { axiosInstance }: VideoAction = action;
    yield axiosInstance.request(
      {
        url: `videos/${action.id}`,
        method: 'delete',
        headers: {
          'Content-Type': 'application/json',
        }
      }
    );
    yield put(getFlights(axiosInstance));
    yield put(deleteVideoSucess(action.id));
  }
  catch (error) {
    yield put(deleteVideoFail(error));
  }
}

export function* watchLoadVideosDetails(): Generator<any, void, any> {
  yield takeEvery(LOAD_VIDEOS_DETAILS, loadVideosDetailsSaga);
};

export function* watchLoadVideoTrack(): Generator<any, void, any> {
  yield takeEvery(LOAD_VIDEO_TRACK, loadVideoTrackSaga);
}

export function* watchDeleteVideos(): Generator<any, void, any> {
  yield takeEvery(DELETE_VIDEO, deleteVideosSaga);
}


// WEBPACK FOOTER //
// ./src/sagas/video.jsx